import {FC, useMemo, Card} from 'external/react'
import { clsx } from 'external/clsx';
import { PackageCourse } from 'types/context/package'
import Course from './Course'

type CourseListProps = {
    source: 'basic' | 'elective' | 'extra'
    courses: PackageCourse[]
    onCourseClick?: (props:any) => void
}

const sourceTextMap = {
    basic: 'Principales',
    elective: 'Electivos',
    extra: 'Complementarios'
}

const CourseList: FC<CourseListProps> = props => {
    const {source, courses, onCourseClick} = props
    const sourceLabel = useMemo(() => sourceTextMap[source], [source])
    const hasCourses = useMemo(() => courses.length > 0, [courses])

    return (
        <Card className={clsx('mt-3', {'d-none': !hasCourses})}>
            <Card.Header className='bg-white d-flex justify-content-between'>
                <h6 style={{ margin: '0' }}>Cursos {sourceLabel}</h6>
            </Card.Header>
            <div className={clsx('bodySubjects', {'d-none': !hasCourses})}>
                {courses.map(course => (
                    <Course key={course.id} {...course} onCourseClick={onCourseClick} source={source} />
                ))}
            </div>
        </Card>
    )
}

export {CourseList as default}